import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export const getImageUrl = (path) => {
  if (!path) return `${API_BASE_URL}/uploads/photos/default-avatar.svg`;
  if (path.startsWith('http')) return path;
  return `${API_BASE_URL}${path}`;
};

export const contactService = {
  getContacts: async (params = {}) => {
    const response = await axios.get(`${API_BASE_URL}/api/contacts`, { params });
    return response.data;
  },

  getContact: async (id) => {
    const response = await axios.get(`${API_BASE_URL}/api/contacts/${id}`);
    return response.data;
  },

  createContact: async (contactData) => {
    const response = await axios.post(`${API_BASE_URL}/api/contacts`, contactData);
    return response.data;
  },

  updateContact: async (id, contactData) => {
    const response = await axios.put(`${API_BASE_URL}/api/contacts/${id}`, contactData);
    return response.data;
  },

  deleteContact: async (id) => {
    await axios.delete(`${API_BASE_URL}/api/contacts/${id}`);
  },

  toggleFavorite: async (id, isFavorite) => {
    const response = await axios.patch(`${API_BASE_URL}/api/contacts/${id}/favorite`, null, {
      params: { is_favorite: isFavorite }
    });
    return response.data;
  },

  uploadPhoto: async (id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`${API_BASE_URL}/api/contacts/${id}/photo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};
